<template>
   <v-container fluid>
      <v-toolbar dense :color="$globalstore.settings_titleclass">
         <v-toolbar-title>
            <template v-if="$vuetify.breakpoint.mobile">
               <v-icon large class="mr-2" @click="goBack()">mdi-chevron-left</v-icon>
            </template>
            CCA Proposal Setting
         </v-toolbar-title>
      </v-toolbar>
      <v-row class="pt-2">
         <v-col cols="6" md="4">
            <v-select
               v-model="termyearselect"
               :items="termyear"
               item-text="termyeartext"
               item-value="id"
               label="Select Term/Year"
               return-object
            >
            </v-select>
         </v-col>
      </v-row>
      <v-row>
         <v-col cols="6" md="6">
            <datepicker-dialog
               labelname="Proposal Open Date"
               :indate.sync="edit_proposal_opendate"
               @return-date="onProposalOpenDateChange"
            >
            </datepicker-dialog>
         </v-col>

         <v-col cols="6" md="6">
            <datepicker-dialog
               labelname="Proposal Close Date"
               :indate.sync="edit_proposal_closedate"
               @return-date="onProposalCloseDateChange"
            >
            </datepicker-dialog>
         </v-col>
      </v-row>
      <v-row justify="space-around">
         <v-col cols="3" md="3">
            <v-btn class="primary" @click="saveProposalSetting">Save</v-btn>
         </v-col>
      </v-row>
      <show-toast ref="toast"></show-toast>
   </v-container>
</template>

<script>
   import DatepickerDialog from "./DatepickerDialog.vue";
   import ShowToast from "@/components/showToast.vue";

   export default {
      inject: ["ShowMessage"],

      components: {
         DatepickerDialog,
         ShowToast,
      },

      data() {
         return {
            termyearselect: null,
            termyear: [],
            edit_proposal_opendate: "",
            edit_proposal_closedate: "",
         };
      },

      methods: {
         goBack() {
            this.$router.go(-1);
         },

         onProposalOpenDateChange(date) {
            this.edit_proposal_opendate = date;
         },

         onProposalCloseDateChange(date) {
            this.edit_proposal_closedate = date;
         },

         saveProposalSetting() {
            if (this.edit_proposal_closedate <= this.edit_proposal_opendate) {
               this.ShowMessage({
                  title: "Error",
                  message: "Close Date must be greater than open date.",
                  color: "red",
               });
               return;
            } else {
               if (
                  this.termyearselect.term != this.$globalstore.appsettings.currentyearterm.term ||
                  this.termyearselect.year != this.$globalstore.appsettings.currentyearterm.year ||
                  this.edit_proposal_opendate != this.$globalstore.appsettings.proposal_opendate ||
                  this.edit_proposal_closedate != this.$globalstore.appsettings.proposal_closedate
               ) {
                  this.doSaveProposalSetting();
               }
            }
         },

         async doSaveProposalSetting() {
            await this.$http({
               url: "/common/updateproposalsetting.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  term: this.termyearselect.term,
                  year: this.termyearselect.year,
                  opendate: this.edit_proposal_opendate,
                  closedate: this.edit_proposal_closedate,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.reloadAppSettings();
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         SetTermYear() {
            if (
               this.$globalstore.appsettings.proposal_year &&
               this.$globalstore.appsettings.proposal_term
            ) {
               this.termyearselect = this.termyear.find(
                  (x) =>
                     x.term == this.$globalstore.appsettings.proposal_term &&
                     x.year == this.$globalstore.appsettings.proposal_year
               );
            } else {
               this.ShowMessage({
                  title: "Error",
                  message: "Default Proposal Year and Term settings not found.",
                  color: "red",
               });
            }
         },

         async reloadAppSettings() {
            await this.$http({
               url: "/common/getappsettings.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {section: "CCA"},
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.$globalstore.appsettings = response.data.appsettings;
               } else {
                  this.ShowMessae({
                     title: "Fatal Error",
                     message: "Unable to read application settings.",
                     color: "red",
                  });
               }
            });
         },
      },

      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.termyear = this.$globalstore.termyearlist;
            this.SetTermYear();
            if (this.$globalstore.appsettings.proposal_opendate) {
               this.edit_proposal_opendate = this.$globalstore.appsettings.proposal_opendate;
            }
            if (this.$globalstore.appsettings.proposal_closedate) {
               this.edit_proposal_closedate = this.$globalstore.appsettings.proposal_closedate;
            }
         }
      },
   };
</script>
